import { useEffect } from 'react'

export function WaltsFood() {
  const divId = 'flipp-container'

  useEffect(() => {
    const onloadFunction = `
      var storefront = new Flipp.Storefront({
        accessToken: "eaba9fe25bb07752e3786d4226daed54",
        merchantId: "2891",
        merchantNameIdentifier: "waltsfoodcenter",
        locale: "en-US",
      });
      storefront.renderStorefront(document.querySelector("#${divId}"));
    `

    const script = document.createElement('script')
    script.src = 'https://aq.flippenterprise.net/2891/iframe.js'
    script.id = 'flipp-storefront-script'

    script.setAttribute('onload', onloadFunction)

    document.body.appendChild(script)

    return () => {
      if (script) {
        script.parentNode.removeChild(script)
      }
    }
  }, [])

  return (
    <div>
      <div id={divId}></div>
    </div>
  )
}